import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/customerSearch",
  },
  {
    path: "/customerSearch",
    name: "customerSearch",
    meta: { title: "卡券查询", icon: "" },
    component: () => import("../views/login/customerLogin.vue"),
  },
  {
    path: "/searchResult",
    name: "searchResult",
    meta: { title: "查询结果", icon: "" },
    component: () => import("../views/searchResult/searchResult.vue"),
  },
  {
    path: "/address",
    name: "address",
    meta: { title: "添加收货地址", icon: "" },
    component: () => import("../views/address/address.vue"),
  },
  {
    path: "/success",
    name: "success",
    meta: { title: "领取成功", icon: "" },
    component: () => import("../views/address/success.vue"),
  },
  {
    path: "/orderDetails",
    name: "orderDetails",
    meta: { title: "订单详情", icon: "" },
    component: () => import("../views/orderDetails/orderDetails.vue"),
  },
  {
    path: "/logistics",
    name: "logistics",
    meta: { title: "物流信息", icon: "" },
    component: () => import("../views/logistics/logistics.vue"),
  },
  {
    path: "/merchantBind",
    name: "merchantBind",
    meta: { title: "商户绑定", icon: "", keepAlive: true },
    component: () => import("../views/merchantBind/merchantBind.vue"),
  },
  {
    path: "/merchantLogin",
    name: "merchantLogin",
    meta: { title: "商户登陆", icon: "" },
    component: () => import("../views/login/merchantLogin.vue"),
  },
  {
    path: "/scanner",
    name: "scanner",
    meta: { title:"扫码绑定", icon: "" },
    component: () => import("../views/merchantBind/scanner.vue"),
  },
  {
    path: "/voucherList",
    name: "voucherList",
    meta: { title: "卡券查询", icon: "" },
    component: () => import("../views/merchantBind/voucherList.vue"),
  },
  {
    path: "/clear",
    name: "clear",
    meta: { title: "清除缓存", icon: "" },
    component: () => import("../views/clear/clear.vue"),
  },
  {
    path: "/loginScanner",
    name: "loginScanner",
    meta: { title: "扫描二维码", icon: "" },
    component: () => import("../views/login/loginScanner.vue"),
  },
  {
    path: "/test",
    name: "test",
    meta: { title: "扫描二维码", icon: "" },
    component: () => import("../views/testScanner/index.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
